var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"tw-w-full tw-h-full",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',[(_vm.error == 404)?[_c('v-lottie-player',{attrs:{"loop":false,"width":"100%","height":"100%","animation-data":require('@/assets/animations/404-not-found.json')}})]:_vm._e()],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }